(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'majorsListing', {
            bindings: {},
            templateUrl:  'app/views/partials/content/majors-listing.html',
            controller:   MajorsListingController,
            controllerAs: 'vm',

            renderingOptions: {
                'majors': {}
            }
        });


    /**
     * Renders list of all available majors and selectors (if available).
     *
     * @param {ng.IScope} $scope
     * @param {Utils} Utils
     * @param {LoggerFactory} LoggerFactory
     * @param {SelectablesService} SelectablesService
     * @param {Object} TEXTS
     * @param {Object} CONFIG
     */
    function MajorsListingController(
        $scope,
        Utils,
        LoggerFactory,
        SelectablesService,
        TEXTS,
        CONFIG
    ){

        /** @type {angular.IController} */
        var vm = this;





        /* ===== PRIVATE MEMBERS ============================================ */


        /** @constant */
        var ITEMS               = SelectablesService.ITEMS;


        /** @type {Logger} */
        var logger = LoggerFactory.createLogger( 'MajorsListingController' );





        /* ===== EXPOSE TO THE SCOPE ======================================== */


        /** @const */
        $scope.ITEMS    = ITEMS;
        $scope.TEXTS    = TEXTS.DEGREE.MAJORS;
        $scope.CONFIG   = CONFIG;

        $scope.DEGREES_SELECTABLE_ID   = 'degreeMajors';




        /* ===== RUN ON INSTANTIATION ======================================= */


        /** *MUST BE* present to allow directive `collapsible` to bind to the Controller's $postLink event. */
        Utils.addGenericPostLinkTrigger( vm );


        /** @constructor */
        vm.$onInit = function() {
            SelectablesService.getSelectablesByIdPromise( $scope.DEGREES_SELECTABLE_ID ).then( function( selectables ) {
                vm.selectablesObject = selectables;
                initMajors();
            }).catch( function( err ) {
                logger.error( err );
            });
        };





        /* ===== PRIVATE FUNCTIONS ========================================== */


        function initMajors() {

            // Model and states
            vm.majors               = vm.selectablesObject.model;
            vm.selectablesConfig    = vm.selectablesObject.config;

            vm.selectorsCount       = vm.selectablesObject.config.selectorsCount;

            // Texts
            /** @deprecated - Use {TEXTS} instead. */
            $scope._  = vm.selectablesObject._;
        }
    }



    MajorsListingController.$inject = [ '$scope', 'Utils', 'LoggerFactory', 'SelectablesService', 'TEXTS', 'CONFIG' ];
})();
